<template>
  <b-modal :id="modalId" centered hide-footer size="xl" header-class="quick-view-header">
    <template slot="modal-title"></template>
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="quickview prod-card-img-wrapper">
            <img class="card-image" :src="getImageUrl(getImage)" alt />
          </div>
        </b-col>
        <ProductDetails
          v-if="prod.id != undefined"
          v-on:change-product="changeProduct"
          :initial_product="currentProd"
          modal="true"
          :product="prod"
        />
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import ProductDetails from "../product-page-components/ProductDetails";

export default {
  name: "QuickViewModal",
  props: ["modalId", "prodId", "prod", "currentProd"],
  components: {
    ProductDetails,
  },
  computed: {
    getImage: function () {
      return this.selectedProduct.Image;
    },
  },
  data() {
    return {
      product: [],
      selectedProduct: [],
    };
  },
  methods: {
    changeProduct(product) {
      this.selectedProduct = product;
    },
    goToProductPage() {},
  },
  mounted() {
    if (this.prod.sizes && this.prod.sizes.length > 0) {
      this.selectedProduct = this.prod.sizes.find(
        (product) => product.Item_id == this.currentProd
      );
    }
    if (this.prod.colors && this.prod.colors.length > 0) {
      this.selectedProduct = this.prod.colors.find(
        (product) => product.Item_id == this.currentProd
      );
    } else {
      this.selectedProduct = this.prod;
    }
  },
};
</script>

<style>
.quick-view-header {
  border-bottom: none;
}
.quickview .card-image {
  max-width: 100%;
  -o-object-fit: contain;
  object-fit: contain;
  -o-object-position: center center;
  object-position: center center;
  border-radius: 5px;
  text-align: center;
  position: relative;
  transform: unset;
  left: 0;
  top: 0;
  max-height: unset;
}
.modal-content {
  min-height: 400px;
  border-radius: 0.9rem;
}
.modal-backdrop {
  background-color: none;
  background-image: url(/images/background_gradient.png);
  background-size: contain;
}
.modal-header {
  position: relative;
}

h5 .modal-title {
  font: small !important;
}

.full-prod-lnk {
  position: absolute;
  right: 8.5%;
  top: 1rem;
  color: #000000;
  text-decoration: none;
  font-size: small !important;
}
@media screen and (max-width: 768px) {
  .full-prod-lnk {
    right: unset;
  }
}
</style>
